module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17D1Ek/tc-custom/9781439623732.jpg?1684305912025",
      "alt": "This image is the cover for the book Along Chautauqua Lake, Postcard History Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Along Chautauqua Lake, Postcard History Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Shortly after settlement began along Chautauqua Lake, steamboats furnished transportation and the first hotel catered to visiting hunters and fishermen. Families escaping the summers in the city soon followed to enjoy the cool, healthy air. Chautauqua Institution and Point Chautauqua both began as religious assembly grounds. Celoron Park, often called the �Coney Island of the West,� and later Midway Park provided entertainment for families and attracted thousands of visitors who traveled by trolley and steamboat in the summer. Local residents and visitors alike enjoyed the parks, picnic groves, and assorted resorts along the lake. A century later, fish are still caught, boats still ply the waters, and families continue to enjoy everything Chautauqua Lake has to offer.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karen E. Livsey, Dorothy E. Levin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Karen E. Livsey is the librarian and archivist at the Fenton History Center-Museum and Research Center in Jamestown. A native of the area, she writes a newspaper column featuring different items from the collection at the Fenton History Center. Dorothy E. Levin has lived near Chautauqua Lake for her entire life. She and her family are avid postcard collectors, and she often travels to postcard shows to expand her collection.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0